import { AuxSecondaryNavigation } from "@blk/aladdin-react-components-es";
import { AuxSecondaryNavigationPositionEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLeftPaneOpen } from "store/left-pane";
import "./insLeftPane.scss";
export const InsLeftPane = ({ children, header, assistiveLabel, paneId }) => {
    const dispatch = useDispatch(), isOpen = useSelector((state) => state.leftPane[paneId]?.isOpen) ?? true;
    const handleDrawerOpen = (setOpen) => {
        dispatch(setIsLeftPaneOpen({ isOpen: setOpen, leftPaneId: paneId }));
    };
    return React.createElement(AuxSecondaryNavigation, { header: header, assistiveLabel: assistiveLabel, isOpen: isOpen, onDrawerOpened: () => handleDrawerOpen(true), onDrawerClosed: () => handleDrawerOpen(false), position: AuxSecondaryNavigationPositionEnum.DRAWER },
        React.createElement("div", { slot: "content", className: "leftPaneContent" }, children));
};
